module.exports = __webpack_public_path__ + "img/product2p.9f985464.png";